export default __webpack_public_path__ + "static/media/DevOops_HTB.0d46cd3e.md";